export enum ClinicTab {
  GENERAL = 0,
  CONDITIONS = 1,
  PRODUCTS = 2,
  LISTING_ORGANISATIONS = 3,
  EXCLUDED_ORGANISATIONS = 4,
  FULFILMENT = 5,
  PRESCRIBERS = 6,
}

export const ClinicTabLabels = {
  [ClinicTab.GENERAL]: 'General',
  [ClinicTab.CONDITIONS]: 'Conditions',
  [ClinicTab.PRODUCTS]: 'Products',
  [ClinicTab.LISTING_ORGANISATIONS]: 'Listing Organisations',
  [ClinicTab.EXCLUDED_ORGANISATIONS]: 'Excluded Organisations',
  [ClinicTab.FULFILMENT]: 'Fulfilment',
  [ClinicTab.PRESCRIBERS]: 'Prescribers'
};
